// extracted by mini-css-extract-plugin
module.exports = {"logo":"WellsFargoLogo__logo___nx2M8","tpb":"WellsFargoLogo__tpb___U5PdC"};